module.exports = __webpack_public_path__ + "media/images/icons/directions-arrow--stroke-fabc0862895b9f30f89500675d3e9cc1.svg";